// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"540a6730","374":"3f870501","584":"34101104","673":"836bb7f9","749":"c3e91f1f"}[chunkId] + ".chunk.js";
};